export enum EDITOR_FIGURE_FOCUS_EVENT_TYPE {
    click = 'click',
    mouseEnter = 'mouse enter',
    mouseLeave = 'mouse leave',
}
